import { NavLink } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { LogOut } from "lucide-react";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle
} from "src/components/ui/sheet";
import { navigationConfig } from "./navConfig";
import { NavItems } from "./NavItems";

interface MobileDrawerProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export function MobileDrawer({ open, onOpenChange }: MobileDrawerProps) {
	const { instance } = useMsal();

	return (
		<Sheet open={open} onOpenChange={onOpenChange}>
			<SheetContent
				side="right"
				className="w-[80vw] max-w-[360px] p-0 flex flex-col"
			>
				<SheetHeader className="border-b border-border px-6 py-4">
					<SheetTitle>
						<NavLink
							to="/"
							onClick={() => onOpenChange(false)}
							className="flex items-center"
						>
							<img src="/mee-logo.svg" alt="Mee" className="h-6" />
						</NavLink>
					</SheetTitle>
				</SheetHeader>
				<div className="flex-1 overflow-y-auto px-4 py-4">
					<NavItems
						items={navigationConfig}
						onNavigate={() => onOpenChange(false)}
					/>
				</div>
				<div className="border-t border-border px-4 py-4">
					<button
						onClick={() => instance.logoutRedirect()}
						className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-muted-foreground transition-all duration-150 hover:bg-accent hover:text-foreground active:scale-[0.98]"
					>
						<LogOut className="h-5 w-5 shrink-0" aria-hidden="true" />
						<span>Sign out</span>
					</button>
				</div>
			</SheetContent>
		</Sheet>
	);
}
